const isDev =
  import.meta.env.VITE_NODE_ENV === 'development' ||
  import.meta.env.MODE === 'development';

type LoggerFunction = (...args: unknown[]) => void;
type LogLevel = 'log' | 'warn' | 'error' | 'info';

interface ILogger {
  log: LoggerFunction;
  warn: LoggerFunction;
  error: LoggerFunction;
  info: LoggerFunction;
}

const createLogger = (): ILogger => {
  const safeLog = (type: LogLevel): LoggerFunction => {
    return (...args: unknown[]) => {
      if (isDev) {
        console[type](`[${type?.toUpperCase()}]:`, ...args);
      }
    };
  };

  return {
    log: safeLog('log'),
    warn: safeLog('warn'),
    error: safeLog('error'),
    info: safeLog('info'),
  };
};

const Logger: ILogger = createLogger();

export default Logger;
